import React, { useState, useEffect, useRef } from 'react';
import Immutable from 'immutable';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import config from 'react-global-configuration';

import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  Pager,
} from '../../../components';

import GarbageCompanyResult from './Result';
import GarbageForm from './Form';
import useSearchApi from './useSearchApi';

import './style.scss';

const GarbageCompanyOverview = () => {
  const API_URL = config.get('API_URL');
  const language = useSelector((state) => state.getIn(['ui', 'language']));
  const [recognitionTerms, setRecognitionTerms] = useState([]);
  const { t } = useTranslation();
  const titleRef = useRef();
  const [
    results,
    query,
    loading,
    doSearch,
    selectedRecognitions,
    setSelectedRecognitions,
  ] = useSearchApi('garbage_company', '', language);

  const [searchTerm, setSearchTerm] = useState(query);

  // Scroll into view data is loaded.
  useEffect(() => {
    if (!loading && titleRef.current) {
      titleRef.current.scrollIntoView();
    }
  }, [loading, titleRef]);

  useEffect(() => {
    const fetchTerms = async () => {
      try {
        const response = await fetch(
          `${API_URL}/nl/api/recognition-terms?_format=json`,
        );
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        setRecognitionTerms(data);
      } catch (err) {
        console.error('Failed to fetch recognition terms:', err);
      }
    };

    fetchTerms();
  }, [API_URL]);

  const items = results.get('results', Immutable.List());
  const list = items.keySeq().map((key) => ({
    key,
    entity: items.get(key),
  })).toArray();


  const currentPage = results.getIn(['pager', 'current_page'], 0);
  const resultsTotal = results.getIn(['pager', 'total_items'], null);
  const totalPages = results.getIn(['pager', 'total_pages'], 0);

  useEffect(() => {
    doSearch(searchTerm, 0, selectedRecognitions);
  }, [searchTerm, doSearch, selectedRecognitions]);

  return (
    <Container className="Search">
      <div className="row">
        <div className="col-12 col-md-10 col-lg-8 offset-md-1 offset-lg-2">
          <div ref={titleRef}>
            <GarbageForm
              onSubmit={() => doSearch(searchTerm, 0, selectedRecognitions)}
              value={searchTerm}
              setSearchValue={setSearchTerm}
              selectOptions={recognitionTerms}
              onSelectedRecognitions={setSelectedRecognitions}
            />
            <div className="Search__results">
              {resultsTotal
                ? (
                  <div>
                    {list.map((item, id) => (
                      <div key={id}>
                        <GarbageCompanyResult entity={item.entity} />
                      </div>
                    ))}
                  </div>
                )
                : (
                  <>
                    {loading && (
                      <div className="Search__result__loading">
                        {t('search.loading')}
                      </div>
                    )}
                    {!loading && (
                      <div className="Search__result__empty">
                        <div>{t('search.result_empty')}</div>
                      </div>
                    )}
                  </>
                )}
            </div>
            <div className="Search__pager">
              <Pager
                key={`garbage_company_page_${currentPage}`}
                setCurrentPage={handleCurrentPage}
                {...{ totalPages, currentPage }}
              />
            </div>
          </div>
        </div>
      </div>
    </Container>
  );

  function handleCurrentPage(page) {
    doSearch(searchTerm, page, selectedRecognitions);
  }
};

export default GarbageCompanyOverview;
